export default {
  setLessons(state, lessons) {
    state.lessons = lessons;
  },
  setCount(state, count) {
    state.count = count;
  },
  setFavorites(state, favorites) {
    state.favorites = favorites;
  }
};
